import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { BROWSE_CATEGORY_PAGE_FACET_FIELD_IDS, FILTERABLE_DISPLAY_BIB_GRID_LIMIT } from 'app/constants/BrowseConstants';
import { deserializeQuerystring, serializeQuerystring } from 'app/helpers/browse/browseQueryHelpers';
import useBrowseFacets from 'app/hooks/useBrowseFacets';
import FilterableDisplayBibGrid from '../shared/FilterableDisplayBibGrid';

const BrowseCategoryLeafPageContainer = () => {
  const searchQueryParams = useSelector(state => state.getIn(['browse', 'categoryPage', 'searchQueryParams']))?.toJS();
  const baseApiParams = {
    ...searchQueryParams,
    limit: FILTERABLE_DISPLAY_BIB_GRID_LIMIT,
    view: 'grouped'
  };

  const {
    displayBibs,
    facetFields,
    handleFilterChange,
    isFetching,
    pagination,
    setShowMoreFieldId,
    unapplyAllFilters
  } = useBrowseFacets({
    baseApiParams,
    baseQuerystring: '',
    deserializeQuerystring,
    includedFieldIds: BROWSE_CATEGORY_PAGE_FACET_FIELD_IDS,
    serializeQuerystring
  });

  const intl = useIntl();

  const appliedFiltersAccessibilityHeading = intl.formatMessage({ id: 'browse_active_filters' });
  const facetsHeading = intl.formatMessage({
    defaultMessage: 'TODO: What message here?',
    id: 'browse_facets'
  });

  if (!facetFields) {
    return null;
  }
  return (
    <div className="container">
      <FilterableDisplayBibGrid
        appliedFiltersAccessibilityHeading={appliedFiltersAccessibilityHeading}
        displayBibs={displayBibs}
        facetFields={facetFields}
        facetsHeading={facetsHeading}
        handleFilterChange={handleFilterChange}
        hasBibRatings
        isFetching={isFetching}
        pagination={pagination}
        setShowMoreFieldId={setShowMoreFieldId}
        unapplyAllFilters={unapplyAllFilters}
      />
    </div>
  );
};

export default BrowseCategoryLeafPageContainer;
